import img1 from './images/BrewberEats.png'
import img2 from './images/Nerd-Talk.png'
import img3 from './images/Budget-Tracker.png'
import img4 from './images/WeatherApp.png'
import img5 from './images/Propagatorz.png'
const projects = [
  {
    name: 'Propagatorz',
    src: img5,
    alt: 'plant help line application',
    git: 'https://github.com/alinz07/Propagatorz',
    live: 'https://propagatorz-plant-help.herokuapp.com/',
  },
    {
      name: 'Brewber',
      src: img1,
      alt: 'application to find breweries near you based on city search',
      git: 'https://github.com/Chris-McLeod2/Brewber',
      live: 'https://hmlessard.github.io/Brewber/',
    },
    { 
      name: 'Nerd-Talk',
      src: img2,
      alt: 'landing page of nerd-talk',
      git: 'https://github.com/Chris-McLeod2/FullStackMedia',
      live: 'https://nerd-talk.herokuapp.com/',
    },
    {
      name: 'Budget PWA',
      src: img3,
      alt: 'budget app with offline functionality',
      git: 'https://github.com/Chris-McLeod2/budgetTrackerPWA',
      live: 'https://young-oasis-45581.herokuapp.com/',
    },
    {
      name: 'Weather App',
      src: img4,
      alt: 'weather app set to river falls for screenshot',
      git: 'https://github.com/Chris-McLeod2/WeatherAPI',
      live: 'https://chris-mcleod2.github.io/WeatherAPI/',
    },
  ];
  
  export default projects;